
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"85"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"transform":"translate(2 2)","filter":"url(#oeamtc-floating__dropshadow)","fill":"var(--color-accent-primary)","d":"M29.5 68.263a3.37 3.37 0 110 6.737 3.37 3.37 0 110-6.737zM29.5 0C45.792 0 59 13.44 59 30.017c0 12.482-7.487 23.184-18.14 27.71-9.09 4.616-10.225 8.852-11.36 8.852-1.135 0-2.27-4.236-11.278-8.817C7.525 53.255 0 42.53 0 30.017 0 13.439 13.208 0 29.5 0z"}}),_c('path',{attrs:{"d":"M24.48 25.76a3.7 3.7 0 013.7-2.26h7.64a3.7 3.7 0 013.7 2.26l.86 3a.5.5 0 01-.34.62h-.24A49.02 49.02 0 0032 29a49.02 49.02 0 00-7.8.4.54.54 0 01-.6-.4.98.98 0 010-.24zm21.52 8a4.56 4.56 0 00-2.74-4.2L42 25.1a6.24 6.24 0 00-6.18-4h-7.64a6.24 6.24 0 00-6.18 4l-1.26 4.46a4.56 4.56 0 00-2.74 4.2V42a2 2 0 004 0v-2h20v2a2 2 0 004 0zM42 36a1.36 1.36 0 010-2.7 1.28 1.28 0 011.18.66 1.32 1.32 0 010 1.38A1.28 1.28 0 0142 36zm-20 0a1.36 1.36 0 010-2.64 1.28 1.28 0 011.14.64 1.32 1.32 0 010 1.38A1.28 1.28 0 0122 36zm15.04 0h-10A1 1 0 0126 35a1 1 0 011-1h10a1 1 0 011 1 1 1 0 01-1 1z"}})])
          )
        }
      }
    